// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"48":"6e7330a8","54":"613a2a0a","166":"002c90ac","232":"02fbf3b0","260":"9e57dafd","310":"2d4ee253","573":"8f5e2e46","730":"6f4aead7","838":"b1196b75","851":"4c24fab3","890":"537c1a90","958":"1d2641bc","990":"e51d3b35"}[chunkId] + ".chunk.js";
};